import Vue from 'vue'
let v = new Vue()
export default {
  baseUrl:v.$utils.Url.sDemo+"/S000/",
  formName:"sDemoSampleForm",
  listName:"sDemoSampleList"
}